/* BritBag PDP, Bold / Product-Led direction. Scoped to .bld / .bld-section. */
(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 990px)';
  /* Fallbacks only. The real labels are rendered from the language content onto
     the section (data-add-label / data-sold-label), so a change there applies
     before and after the script runs. */
  var ADD_LABEL = 'Add to Basket';
  var PRE_LABEL = 'Pre-Order';
  var SOLD_LABEL = 'Sold Out';
  var BUSY_LABEL = 'Adding…';
  var GENERIC_ERROR = 'Sorry, we could not add this to your basket. Please try again.';
  var NETWORK_ERROR = 'Sorry, something went wrong. Please check your connection and try again.';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function optKey(i) {
    return 'option' + (i + 1);
  }

  /* Money formatting that honours the shop's money_format ({{amount}}, {{amount_no_decimals}}, etc.). */
  function formatMoney(cents, format) {
    var value = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    var fmt = String(format || '£{{amount}}').replace(/<[^>]*>/g, '');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';

    function delimit(precision, thousands, decimal) {
      var fixed = (value / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var out;
    switch (type) {
      case 'amount_no_decimals': out = delimit(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(2, "'", '.'); break;
      case 'amount_with_space_separator': out = delimit(2, ' ', ','); break;
      default: out = delimit(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function BoldPdp(root) {
    this.root = root;
    this.addLabel = root.dataset.addLabel || ADD_LABEL;
    this.preLabel = root.dataset.preLabel || PRE_LABEL;
    this.soldLabel = root.dataset.soldLabel || SOLD_LABEL;
    this.showInStock = root.dataset.showInStock === 'true';
    this.section = root.closest('.bld-section') || document;
    this.data = window.BoldPdpData || {};
    this.variants = this.data.variants || [];
    this.options = this.data.options || [];
    this.imageIds = this.data.imageIds || [];
    this.moneyFormat = this.data.moneyFormat || '£{{amount}}';
    this.colourIdx = this.options.findIndex(function (n) { return /colou?r/i.test(n); });
    this.variant = this.data.selectedVariant || this.variants[0] || null;
    this.sel = {};
    this.busy = false;
    this.stickyOn = false;

    this.form = root.querySelector('.bld__form');
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.qtyInput = root.querySelector('.bld__qty-num');
    this.mainBtn = root.querySelector('[data-bld-add]');
    this.mainError = root.querySelector('[data-bld-error]');
    this.gallery = root.querySelector('[data-pgal]');
    this.lightboxData = this.data.lightbox || [];

    this.sticky = this.section.querySelector('[data-bld-sticky]');
    this.stickyBtn = this.sticky ? this.sticky.querySelector('[data-bld-sticky-add]') : null;
    this.stickyError = this.sticky ? this.sticky.querySelector('[data-bld-sticky-error]') : null;

    /* Each feature is initialised in isolation. Previously one throw anywhere
       in this list silently killed every feature after it — a broken gallery
       would take the accordions and the cart down with it and leave nothing in
       the console to say so. */
    [
      'initViewportMetrics',
      'initGallery',
      'initLightbox',
      'initStickyInfo',
      'initVariants',
      'initAccordions',
      'initAnchors',
      'initQty',
      'initCart',
      'initSticky'
    ].forEach(function (name) {
      try {
        this[name]();
      } catch (err) {
        if (window.console) console.error('[pdp-gallery] ' + name + ' failed:', err);
      }
    }, this);

    if (this.variant) {
      try {
        this.render(this.variant, true);
      } catch (err) {
        if (window.console) console.error('[pdp-gallery] initial render failed:', err);
      }
    }
  }

  BoldPdp.prototype.headerOffset = function () {
    /* Prefer the value measured for the gallery, so anchors and the category
       chips land at the same place the sticky elements clear to. */
    var measured = this.chromeTop();
    if (measured > 0) return measured;
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if (!isNaN(v) && v > 0) return v;
    var header = document.querySelector('.section-header');
    return header ? header.offsetHeight : 0;
  };

  BoldPdp.prototype.scrollToEl = function (el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - this.headerOffset() - 24;
    window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion() ? 'auto' : 'smooth' });
  };

  /* ───────────── Gallery ─────────────
     Hero carousel (sticky beside the stream on desktop, swipeable on mobile),
     plus scroll-spy category chips that jump the stream on desktop and the
     hero carousel on mobile. */
  BoldPdp.prototype.initGallery = function () {
    var self = this;
    var root = this.root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.pgal__slide'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('.pgal__thumb'));
    this.ticks = Array.prototype.slice.call(root.querySelectorAll('.pgal__tick'));
    this.rail = root.querySelector('.pgal__rail');
    this.counterEl = root.querySelector('[data-pgal-counter]');
    this.groupLabelEl = root.querySelector('[data-pgal-group-label]');
    this.current = 0;

    this.initChips();

    if (this.slides.length < 2) return;

    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.go(parseInt(thumb.dataset.index, 10) || 0);
      });
    });

    this.ticks.forEach(function (tick) {
      tick.addEventListener('click', function () {
        self.go(parseInt(tick.dataset.index, 10) || 0);
      });
    });

    var prev = root.querySelector('[data-pgal-prev]');
    var next = root.querySelector('[data-pgal-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.current - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.current + 1); });

    var stage = root.querySelector('.pgal__stage');
    if (!stage) return;

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.current - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.current + 1); }
      else if (e.key === 'Home') { e.preventDefault(); self.go(0); }
      else if (e.key === 'End') { e.preventDefault(); self.go(self.slides.length - 1); }
    });

    /* Swipe (touch-action: pan-y in CSS keeps vertical page scroll native).
       A swipe must not also fire the zoom button underneath it. */
    var startX = null;
    var startY = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      startX = e.clientX;
      startY = e.clientY;
      self.swiped = false;
    });
    stage.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        self.swiped = true;
        self.go(self.current + (dx < 0 ? 1 : -1));
      }
    });
    stage.addEventListener('pointercancel', function () {
      startX = startY = null;
      self.swiped = false;
    });
    stage.addEventListener('pointerleave', function () { startX = startY = null; });

    /* Liquid marks the first slide active, but the ticks and stream tiles have
       no initial state and go() is not called on first paint. Sync once. */
    this.go(this.current);
  };

  /* Category chips: scroll-spy on desktop, carousel jump on mobile. */
  BoldPdp.prototype.initChips = function () {
    var self = this;
    var root = this.root;
    this.chips = Array.prototype.slice.call(root.querySelectorAll('[data-pgal-jump]'));
    if (!this.chips.length) return;

    var groups = Array.prototype.slice.call(root.querySelectorAll('.pgal__group[data-group]'));
    var desktop = window.matchMedia(DESKTOP_MQ);

    this.chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.dataset.pgalJump;
        if (desktop.matches) {
          var target = root.querySelector('.pgal__group[data-group="' + key + '"]');
          if (target) self.scrollToEl(target);
        } else {
          var slide = root.querySelector('.pgal__slide[data-group="' + key + '"]');
          if (slide) self.go(parseInt(slide.dataset.index, 10) || 0);
        }
        self.setChip(key);
      });
    });

    /* Spy: the group occupying the middle of the viewport wins. */
    if (!('IntersectionObserver' in window) || !groups.length) return;
    this.spy = new IntersectionObserver(function (entries) {
      if (!desktop.matches) return;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) self.setChip(entry.target.dataset.group);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    groups.forEach(function (g) { self.spy.observe(g); });
  };

  BoldPdp.prototype.setChip = function (key) {
    if (!this.chips) return;
    this.chips.forEach(function (chip) {
      var on = chip.dataset.pgalJump === key;
      chip.classList.toggle('is-current', on);
      if (on) chip.setAttribute('aria-current', 'true');
      else chip.removeAttribute('aria-current');
    });
  };

  BoldPdp.prototype.go = function (i) {
    var n = this.slides.length;
    if (!n) return;
    var idx = ((i % n) + n) % n;
    this.current = idx;

    this.slides.forEach(function (slide, k) {
      var on = k === idx;
      slide.classList.toggle('is-active', on);
      if (on) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });

    this.thumbs.forEach(function (thumb, k) {
      var on = k === idx;
      thumb.classList.toggle('is-active', on);
      if (on) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });

    this.ticks.forEach(function (tick, k) {
      var on = k === idx;
      tick.classList.toggle('is-active', on);
      tick.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    if (this.counterEl) this.counterEl.textContent = String(idx + 1).padStart(2, '0');

    var active = this.slides[idx];

    /* Name what is on screen. Blank for uncategorised images rather than a
       filler word, so the slot simply reads as empty. */
    if (this.groupLabelEl && active) {
      this.groupLabelEl.textContent = active.dataset.groupLabel || '';
    }

    /* Mirror the active slide's category onto the chips on mobile. */
    if (active && active.dataset.group && !window.matchMedia(DESKTOP_MQ).matches) {
      this.setChip(active.dataset.group);
    }

    /* Keep the active thumb in view inside the rail only (never scroll the page). */
    var thumb = this.thumbs[idx];
    var rail = this.rail;
    if (thumb && rail && rail.scrollWidth > rail.clientWidth + 1) {
      var left = thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2;
      rail.scrollTo({ left: Math.max(0, left), behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
  };

  /* Height of fixed chrome at the top of the viewport, in pixels. */
  BoldPdp.prototype.chromeTop = function () {
    var v = parseFloat(this.root.style.getPropertyValue('--bld-header-h'));
    return isNaN(v) ? 0 : v;
  };

  /* ───────────── Viewport metrics ─────────────
     Publishes the height of the two pieces of fixed chrome that eat into the
     usable viewport — the theme header and the basket bar — so the gallery can
     size itself against what is actually visible.

     The header only counts when it is sticky or fixed; a header that scrolls
     away steals no space once you are past it, and reserving for it would
     shrink the image for nothing. Measured on load and resize rather than on
     scroll: a header that shrinks as you scroll would otherwise resize the
     image continuously, which is worse than a few reserved pixels. */
  BoldPdp.prototype.initViewportMetrics = function () {
    var self = this;
    var root = this.root;
    var queued = false;

    /* Anything that can pin itself to the top of the viewport. The USP bar is
       a sibling of the header rather than part of it, so both have to be
       counted or the hero image is sized against a gap that is not there. */
    var chrome = [
      document.querySelector('.usp-bar-section'),
      document.querySelector('.section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('header')
    ].filter(Boolean);

    function measure() {
      queued = false;

      /* Only elements actually pinned count: one that scrolls away steals no
         space once you are past it. */
      var h = chrome.reduce(function (total, el) {
        var pos = window.getComputedStyle(el).position;
        if (pos !== 'sticky' && pos !== 'fixed') return total;
        return total + Math.round(el.getBoundingClientRect().height);
      }, 0);
      root.style.setProperty('--bld-header-h', h + 'px');

      var bar = self.sticky ? Math.round(self.sticky.getBoundingClientRect().height) : 0;
      root.style.setProperty('--bld-bar-h', bar + 'px');
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(measure);
    }

    measure();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      chrome.forEach(function (el) { ro.observe(el); });
      if (this.sticky) ro.observe(this.sticky);
    }
  };

  /* ───────────── Sticky product information ─────────────
     A column taller than the viewport cannot be pinned by CSS alone: holding
     its END requires a negative `top` equal to how far it overflows, and only
     measurement knows that number. `bottom` sticky is not an alternative — it
     engages while scrolling up, pinning the column before you reach it and
     releasing it afterwards, which is backwards for this.
     Re-measured whenever the column grows (an accordion opening) or the
     window changes. */
  BoldPdp.prototype.initStickyInfo = function () {
    var self = this;
    var info = this.root.querySelector('.bld__info');
    if (!info) return;

    var mq = window.matchMedia(DESKTOP_MQ);
    var queued = false;
    var GAP = 16;

    function apply() {
      queued = false;
      if (!mq.matches) {
        info.style.removeProperty('--bld-info-top');
        return;
      }

      /* Measure the elements rather than reading the published custom
         properties, which are in rem in their CSS fallback form and would
         parse as pixels. */
      var barH = self.sticky ? self.sticky.offsetHeight : 0;
      var headerH = self.chromeTop();
      var avail = window.innerHeight - headerH - barH - GAP;
      var overflow = info.offsetHeight - avail;

      info.style.setProperty(
        '--bld-info-top',
        (overflow > 0 ? headerH - overflow : headerH + GAP) + 'px'
      );
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(apply);
    }

    apply();
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(info);
  };

  /* ───────────── PhotoBox ─────────────
     A native <dialog> driven with showModal(). The browser supplies the top
     layer — so no z-index race with the theme header, and no ancestor
     transform can break its positioning — plus focus trapping and inerting of
     the page behind it. The previous version hand-rolled all of that as a
     fixed div and reparented itself to <body>, which moved it out of
     .bld-section and away from every design token it needed. */
  BoldPdp.prototype.initLightbox = function () {
    var self = this;
    var lb = this.section.querySelector('[data-pgal-lb]');
    if (!lb || typeof lb.showModal !== 'function') return;

    this.lb = lb;
    this.lbImg = lb.querySelector('[data-pgal-lb-img]');
    this.lbCounter = lb.querySelector('[data-pgal-lb-counter]');
    this.lbStrip = lb.querySelector('[data-pgal-lb-strip]');
    this.lbThumbs = Array.prototype.slice.call(lb.querySelectorAll('[data-pgal-lb-go]'));
    this.lbIndex = 0;
    this.lbReturn = null;
    this.lbTimer = null;

    /* Hero image and every stream tile share one index space, so prev/next
       stays continuous no matter which image was clicked to get here. */
    this.root.querySelectorAll('[data-pgal-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (self.swiped) { self.swiped = false; return; }
        e.preventDefault();
        /* showModal() runs synchronously inside this click. With a mouse the
           click finishes before the dialog joins the hit-test path, but on
           touch the dialog appears under the finger and the same tap lands on
           the backdrop, which closes it again — the viewer appeared to do
           nothing at all on a phone. */
        e.stopPropagation();
        self.openLightbox(parseInt(btn.dataset.pgalOpen, 10) || 0, btn);
      });
    });

    this.lbThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.lbGo(parseInt(thumb.dataset.pgalLbGo, 10) || 0);
      });
    });

    lb.querySelectorAll('[data-pgal-lb-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.closeLightbox(); });
    });

    var prev = lb.querySelector('[data-pgal-lb-prev]');
    var next = lb.querySelector('[data-pgal-lb-next]');
    if (prev) prev.addEventListener('click', function () { self.lbGo(self.lbIndex - 1); });
    if (next) next.addEventListener('click', function () { self.lbGo(self.lbIndex + 1); });

    /* Close on a click in the empty dark area. Testing `e.target === lb` does
       not work here: the panel fills the dialog, so the dialog itself is never
       the target. Test for the content instead and treat everything else as
       backdrop. */
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.pgal-lb__figure, .pgal-lb__nav, .pgal-lb__close, .pgal-lb__foot')) return;
      /* A tap that opened the viewer can still be delivered to it afterwards
         on touch. Anything within a gesture's length of the open is that tap,
         not a deliberate dismissal. */
      if (Date.now() - (self.lbOpenedAt || 0) < 400) return;
      self.closeLightbox();
    });

    /* Escape raises the dialog's own cancel event. Take it over so closing
       always runs through one path and the page lock is released. */
    lb.addEventListener('cancel', function (e) {
      e.preventDefault();
      self.closeLightbox();
    });

    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.lbGo(self.lbIndex - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.lbGo(self.lbIndex + 1); }
      else if (e.key === 'Home') { e.preventDefault(); self.lbGo(0); }
      else if (e.key === 'End') { e.preventDefault(); self.lbGo(self.lightboxData.length - 1); }
    });

    var fig = lb.querySelector('.pgal-lb__figure');
    if (fig) {
      var sx = null;
      var sy = null;
      fig.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        sx = e.clientX;
        sy = e.clientY;
      });
      fig.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx;
        var dy = e.clientY - sy;
        sx = sy = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          self.lbGo(self.lbIndex + (dx < 0 ? 1 : -1));
        }
      });
      fig.addEventListener('pointercancel', function () { sx = sy = null; });
    }
  };

  BoldPdp.prototype.openLightbox = function (index, trigger) {
    var lb = this.lb;
    if (!lb) return;

    /* Reopening during the closing fade would call showModal() on an already
       open dialog, which throws. */
    if (this.lbTimer) {
      window.clearTimeout(this.lbTimer);
      this.lbTimer = null;
    }

    this.lbReturn = trigger || null;
    this.lbScrollY = window.scrollY;
    this.lbOpenedAt = Date.now();

    /* Lock the page without the content jumping sideways as the scrollbar goes. */
    var gutter = window.innerWidth - document.documentElement.clientWidth;
    if (gutter > 0) document.body.style.paddingRight = gutter + 'px';
    document.body.classList.add('pgal-lb-open');

    if (!lb.open) lb.showModal();
    this.lbGo(index);

    /* Next frame, so the fade runs from the closed state. */
    window.requestAnimationFrame(function () { lb.classList.add('is-open'); });
  };

  BoldPdp.prototype.lbGo = function (i) {
    var list = this.lightboxData;
    var n = list.length;
    if (!n || !this.lbImg) return;

    var idx = ((i % n) + n) % n;
    this.lbIndex = idx;

    this.lbImg.src = list[idx].src;
    this.lbImg.alt = list[idx].alt || '';
    if (this.lbCounter) this.lbCounter.textContent = (idx + 1) + ' / ' + n;

    var self = this;
    this.lbThumbs.forEach(function (thumb, k) {
      var on = k === idx;
      thumb.classList.toggle('is-active', on);
      if (on) {
        thumb.setAttribute('aria-current', 'true');
        self.lbRevealThumb(thumb);
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    /* Warm the neighbours so paging feels instant. */
    if (n > 1) {
      [list[(idx + 1) % n], list[(idx - 1 + n) % n]].forEach(function (item) {
        if (item && item.src) { var pre = new Image(); pre.src = item.src; }
      });
    }
  };

  /* Centre the active thumbnail inside the strip only — never scroll the page. */
  BoldPdp.prototype.lbRevealThumb = function (thumb) {
    var strip = this.lbStrip;
    if (!strip || strip.scrollWidth <= strip.clientWidth + 1) return;
    var left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
    strip.scrollTo({ left: Math.max(0, left), behavior: reducedMotion() ? 'auto' : 'smooth' });
  };

  BoldPdp.prototype.closeLightbox = function () {
    var lb = this.lb;
    if (!lb || !lb.open) return;

    var self = this;
    lb.classList.remove('is-open');
    document.body.classList.remove('pgal-lb-open');
    document.body.style.paddingRight = '';

    function finish() {
      self.lbTimer = null;
      lb.close();
      /* Releasing the scroll lock can nudge the page; put it back where the
         customer left it, then return focus to the image they came from. */
      if (typeof self.lbScrollY === 'number') window.scrollTo(0, self.lbScrollY);
      if (self.lbReturn) {
        self.lbReturn.focus();
        self.lbReturn = null;
      }
    }

    if (reducedMotion()) finish();
    else this.lbTimer = window.setTimeout(finish, 200);
  };

  /* ───────────── Variants ───────────── */
  BoldPdp.prototype.initVariants = function () {
    var self = this;
    this.optionButtons = Array.prototype.slice.call(
      this.root.querySelectorAll('button.bld__swatch, button.bld__size')
    );

    this.optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.select(btn.dataset.option, btn.dataset.value);
      });
    });

    /* Combined-listing links (Shopify-provided product_url): keep the preview ?view= param. */
    var view = new URLSearchParams(window.location.search).get('view');
    if (view) {
      this.root.querySelectorAll('a[data-bld-link]').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.origin);
          u.searchParams.set('view', view);
          a.setAttribute('href', u.pathname + u.search + u.hash);
        } catch (e) { /* leave href untouched */ }
      });
    }
  };

  BoldPdp.prototype.findVariant = function (sel) {
    var options = this.options;
    return this.variants.find(function (v) {
      return options.every(function (n, i) { return v[optKey(i)] === sel[n]; });
    }) || null;
  };

  BoldPdp.prototype.select = function (opt, val) {
    var idx = this.options.indexOf(opt);
    if (idx < 0) return;

    var next = Object.assign({}, this.sel);
    next[opt] = val;

    var v = this.findVariant(next);
    if (!v) {
      /* Combination does not exist: pick the closest variant that has the chosen value,
         preferring ones that keep the other selections and are in stock. */
      var options = this.options;
      var key = optKey(idx);
      var candidates = this.variants.filter(function (x) { return x[key] === val; });
      if (!candidates.length) return;
      var score = function (x) {
        return options.reduce(function (s, n, i) { return s + (x[optKey(i)] === next[n] ? 1 : 0); }, 0) +
          (x.available ? 0.5 : 0);
      };
      candidates.sort(function (a, b) { return score(b) - score(a); });
      v = candidates[0];
    }

    this.clearErrors();
    this.render(v, false);
  };

  BoldPdp.prototype.render = function (v, initial) {
    var self = this;
    this.variant = v;
    this.options.forEach(function (n, i) { self.sel[n] = v[optKey(i)]; });

    this.optionButtons.forEach(function (b) {
      var on = self.sel[b.dataset.option] === b.dataset.value;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.root.querySelectorAll('[data-bld-option-val]').forEach(function (el) {
      el.textContent = self.sel[el.dataset.bldOptionVal] || '';
    });

    this.updateAvailability();
    if (this.idInput) this.idInput.value = v.id;
    this.updatePrice(v);
    this.updateStock(v);
    this.updateButtons();
    this.updateHeadline(v);
    this.updateStickySelection();

    if (initial) return;

    var imgId = v.featured_image ? v.featured_image.id : (v.featured_media && v.featured_media.preview_image ? v.featured_media.preview_image.id : null);
    if (imgId) {
      var imgIdx = this.imageIds.indexOf(imgId);
      if (imgIdx > -1) this.go(imgIdx);
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) { /* ignore */ }
  };

  BoldPdp.prototype.updateAvailability = function () {
    var self = this;
    this.optionButtons.forEach(function (b) {
      var idx = self.options.indexOf(b.dataset.option);
      if (idx < 0) return;
      var ok = self.variants.some(function (v) {
        if (!v.available || v[optKey(idx)] !== b.dataset.value) return false;
        return self.options.every(function (n, j) { return j === idx || v[optKey(j)] === self.sel[n]; });
      });
      b.classList.toggle('is-unavailable', !ok);
      b.setAttribute('aria-label', b.dataset.value + (ok ? '' : ', sold out'));
    });
  };

  BoldPdp.prototype.updateHeadline = function (v) {
    var el = this.root.querySelector('[data-bld-headline]');
    if (!el) return;
    var others = [];
    var colour = '';
    var colourIdx = this.colourIdx;
    this.options.forEach(function (n, i) {
      var val = v[optKey(i)];
      if (!val || n.toLowerCase() === 'title') return;
      if (i === colourIdx) colour = val;
      else others.push(val);
    });
    var text = others.length && colour ? others.join(' · ') + ' in ' + colour : (others.join(' · ') || colour);
    el.textContent = text;
    el.hidden = !text;
  };

  BoldPdp.prototype.updatePrice = function (v) {
    var fmt = this.moneyFormat;
    var root = this.root;
    var sale = !!(v.compare_at_price && v.compare_at_price > v.price);

    var price = root.querySelector('[data-bld-price]');
    if (price) price.textContent = formatMoney(v.price, fmt);

    var was = root.querySelector('[data-bld-was]');
    var wasAmt = root.querySelector('[data-bld-was-amount]');
    if (was) was.hidden = !sale;
    if (wasAmt && sale) wasAmt.textContent = formatMoney(v.compare_at_price, fmt);

    var badge = root.querySelector('[data-bld-badge]');
    if (badge) {
      badge.hidden = !sale;
      if (sale) badge.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
    }

    var bnpl = root.querySelector('[data-bld-bnpl]');
    if (bnpl) bnpl.textContent = formatMoney(Math.ceil(v.price / 3), fmt);

    if (this.sticky) {
      var sp = this.sticky.querySelector('[data-bld-sticky-price]');
      if (sp) sp.textContent = formatMoney(v.price, fmt);
    }
  };

  BoldPdp.prototype.updateStock = function (v) {
    var el = this.root.querySelector('[data-bld-stock]');
    if (!el) return;
    el.classList.toggle('is-out', !v.available);
    el.hidden = !!v.available && !this.showInStock;
    var text = el.querySelector('[data-bld-stock-text]');
    if (text) text.textContent = v.available ? 'In stock, ready to dispatch' : 'Currently out of stock';
  };

  /* Which of the three button states a variant is in: in_stock, pre_order or
     sold_out. The rule lives in snippets/cta-state.liquid; the section hands the
     result over per variant (data.cta) because the variant JSON leaves out stock
     level and policy. available alone is not enough: it is true for pre-orders too. */
  BoldPdp.prototype.ctaState = function (v) {
    if (!v || !v.available) return 'sold_out';
    var map = this.data.cta || {};
    return map[v.id] || 'in_stock';
  };

  BoldPdp.prototype.updateButtons = function () {
    var state = this.ctaState(this.variant);
    var available = state !== 'sold_out';
    var busy = this.busy;
    var text = state === 'sold_out' ? this.soldLabel : (state === 'pre_order' ? this.preLabel : this.addLabel);
    [this.mainBtn, this.stickyBtn].forEach(function (b) {
      if (!b || b.classList.contains('is-loading')) return;
      b.disabled = !available || busy;
      var label = b.querySelector('[data-bld-add-label]');
      if (label) label.textContent = text;
    });
  };

  BoldPdp.prototype.activeHex = function () {
    var sw = this.root.querySelector('.bld__swatch.is-active');
    return sw && sw.dataset.hex ? sw.dataset.hex : '';
  };

  BoldPdp.prototype.updateStickySelection = function () {
    if (!this.sticky) return;
    var self = this;
    this.sticky.querySelectorAll('[data-bld-sticky-val]').forEach(function (el) {
      el.textContent = self.sel[el.dataset.bldStickyVal] || '';
    });
    this.sticky.querySelectorAll('[data-bld-goto]').forEach(function (b) {
      var name = b.dataset.bldGoto;
      var group = self.groupFor(name);
      var keyEl = group ? group.querySelector('.bld__option-key') : null;
      var key = keyEl ? keyEl.textContent.trim() : name;
      b.setAttribute('aria-label', key + ': ' + (self.sel[name] || '') + '. Change ' + key.toLowerCase());
    });
    var dot = this.sticky.querySelector('[data-bld-sticky-dot]');
    var hex = this.activeHex();
    if (dot && hex) dot.style.setProperty('--sw', hex);

    /* The bar's colour dots and size chips follow the main block: selected, and
       struck through when no available variant matches the other selections. */
    this.sticky.querySelectorAll('[data-bld-sticky-opt]').forEach(function (el) {
      var idx = self.options.indexOf(el.dataset.option);
      if (idx < 0) return;
      var value = el.dataset.value;
      /* Options of a linked product keep the availability the server rendered,
         as in the main block: this product has no variant to check them against. */
      if (el.hasAttribute('data-bld-linked')) {
        el.classList.toggle('is-selected', self.sel[el.dataset.option] === value);
        return;
      }
      var ok = self.variants.some(function (v) {
        if (!v.available || v[optKey(idx)] !== value) return false;
        return self.options.every(function (n, j) { return j === idx || v[optKey(j)] === self.sel[n]; });
      });
      el.classList.toggle('is-selected', self.sel[el.dataset.option] === value);
      el.classList.toggle('is-unavailable', !ok);
    });
  };

  BoldPdp.prototype.groupFor = function (name) {
    var groups = this.root.querySelectorAll('[data-bld-option-group]');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].dataset.bldOptionGroup === name) return groups[i];
    }
    return null;
  };

  /* ───────────── Accordions (height handled by CSS grid rows: smooth and resize-safe) ───────────── */
  BoldPdp.prototype.initAccordions = function () {
    var self = this;

    /* One delegated listener rather than one per button. A click anywhere in
       the column is resolved to its accordion at the moment it happens, so
       this keeps working regardless of how the panels were rendered or how
       many there are. */
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest('.bld__acc-btn');
      if (!btn) return;
      var acc = btn.closest('.bld__accordion');
      if (!acc || !self.root.contains(acc)) return;
      e.preventDefault();
      self.setAccordion(acc, btn.getAttribute('aria-expanded') !== 'true');
    });

    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target && target.classList.contains('bld__accordion') && this.root.contains(target)) {
        this.setAccordion(target, true);
      }
    }
  };

  BoldPdp.prototype.setAccordion = function (acc, open) {
    var btn = acc.querySelector('.bld__acc-btn');
    acc.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  /* ───────────── Description / Specifications anchors ───────────── */
  BoldPdp.prototype.initAnchors = function () {
    var self = this;
    this.root.querySelectorAll('[data-bld-anchor]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        var target = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
        if (!target) return;
        e.preventDefault();
        self.setAccordion(target, true);
        self.scrollToEl(target);
        var btn = target.querySelector('.bld__acc-btn');
        if (btn) btn.focus({ preventScroll: true });
      });
    });
  };

  /* ───────────── Quantity ───────────── */
  BoldPdp.prototype.initQty = function () {
    var input = this.qtyInput;
    if (!input) return;
    var min = 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;
    function clamp(n) { return Math.min(max, Math.max(min, n || min)); }

    this.root.querySelectorAll('[data-qty-dec]').forEach(function (b) {
      b.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) - 1); });
    });
    this.root.querySelectorAll('[data-qty-inc]').forEach(function (b) {
      b.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) + 1); });
    });
    input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10)); });
  };

  /* ───────────── Add to Basket (cart drawer) ───────────── */
  BoldPdp.prototype.initCart = function () {
    var self = this;
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.addToBasket(self.mainBtn);
      });
    }
    if (this.stickyBtn) {
      this.stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToBasket(self.stickyBtn);
      });
    }
    if (document.querySelector('cart-drawer')) {
      [this.mainBtn, this.stickyBtn].forEach(function (b) { if (b) b.setAttribute('aria-haspopup', 'dialog'); });
    }
  };

  BoldPdp.prototype.addToBasket = function (btn) {
    var self = this;
    var v = this.variant;
    if (this.busy || !v || !v.available) return;

    var id = parseInt(this.idInput ? this.idInput.value : v.id, 10);
    var quantity = Math.max(1, parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1);
    var cart = document.querySelector('cart-drawer');
    var hasDrawer = !!(cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function');

    var body = { items: [{ id: id, quantity: quantity }] };
    if (hasDrawer) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn || document.activeElement);
    }

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (!/\.js$/.test(url)) url += '.js';

    this.clearErrors();
    this.setLoading(btn, true);

    var canPublish = typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        var json = result.json;
        if (!result.ok || !json || json.status) {
          var msg = (json && (json.description || json.message)) || GENERIC_ERROR;
          if (canPublish && PUB_SUB_EVENTS.cartError) {
            window.publish(PUB_SUB_EVENTS.cartError, {
              source: 'pdp-gallery',
              productVariantId: id,
              errors: json ? json.errors || json.description : null,
              message: json ? json.message : null
            });
          }
          self.showError(btn, msg);
          return;
        }

        if (!hasDrawer) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        /* The item is in the cart from here on. A failure while updating the
           drawer is not a connection problem, so it is logged for what it is and
           the drawer and count are refreshed another way. */
        try {
          if (canPublish && PUB_SUB_EVENTS.cartUpdate) {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-gallery', productVariantId: id, cartData: json });
          }
          cart.classList.remove('is-empty');
          cart.renderContents(json);
        } catch (error) {
          console.error('Added to basket, but the cart drawer did not update', error);
          self.refreshCartUi(cart);
        }
      })
      .catch(function (error) {
        console.error('Add to basket request failed', error);
        self.showError(btn, NETWORK_ERROR);
      })
      .then(function () {
        self.setLoading(btn, false);
      });
  };

  /* Fallback when the drawer's own update fails: reload the drawer and the count
     from the server and open the drawer; if that fails too, go to the cart page. */
  BoldPdp.prototype.refreshCartUi = function (cart) {
    var parser = new DOMParser();
    fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = sections['cart-icon-bubble'] && parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && bubbleHtml) bubble.innerHTML = bubbleHtml.innerHTML;
        var drawer = document.querySelector('#CartDrawer');
        var drawerHtml = sections['cart-drawer'] && parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (drawer && drawerHtml) drawer.innerHTML = drawerHtml.innerHTML;
        cart.classList.remove('is-empty');
        if (typeof cart.open === 'function') cart.open();
      })
      .catch(function (error) {
        console.error('Could not refresh the cart', error);
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
  };

  BoldPdp.prototype.setLoading = function (btn, on) {
    this.busy = on;
    if (btn) {
      btn.classList.toggle('is-loading', on);
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      var label = btn.querySelector('[data-bld-add-label]');
      if (on) {
        btn.disabled = true;
        if (label) label.textContent = BUSY_LABEL;
      }
    }
    this.updateButtons();
  };

  BoldPdp.prototype.showError = function (btn, msg) {
    if (this.mainError) {
      this.mainError.textContent = msg;
      this.mainError.hidden = false;
    }
    if (btn && btn === this.stickyBtn && this.stickyError) {
      this.stickyError.textContent = msg;
      this.stickyError.hidden = false;
    }
  };

  BoldPdp.prototype.clearErrors = function () {
    [this.mainError, this.stickyError].forEach(function (el) {
      if (el) { el.hidden = true; el.textContent = ''; }
    });
  };

  /* ───────────── Sticky Add to Basket bar ───────────── */
  BoldPdp.prototype.initSticky = function () {
    var self = this;
    var bar = this.sticky;
    if (!bar) return;

    var setHeight = function () {
      document.documentElement.style.setProperty('--bld-sticky-h', bar.offsetHeight + 'px');
    };
    setHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(bar);
    else window.addEventListener('resize', setHeight);

    var target = this.root.querySelector('.bld__atc-row') || this.mainBtn;
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        var rootTop = entry.rootBounds ? entry.rootBounds.top : 0;
        /* Show only once the main CTA has been scrolled past (above the viewport). */
        self.showSticky(!entry.isIntersecting && entry.boundingClientRect.bottom <= rootTop + 1);
      }).observe(target);
    }

    bar.querySelectorAll('[data-bld-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        var group = self.groupFor(b.dataset.bldGoto);
        if (!group) return;
        self.scrollToEl(group);
        self.flash(group);
        var focusEl = group.querySelector('.is-active') || group.querySelector('button, a');
        if (focusEl) focusEl.focus({ preventScroll: true });
      });
    });

    var toTop = bar.querySelector('[data-bld-to-top]');
    if (toTop) {
      toTop.addEventListener('click', function () {
        self.scrollToEl(self.root);
        var h1 = self.root.querySelector('.bld__style-name');
        if (h1) {
          h1.setAttribute('tabindex', '-1');
          h1.focus({ preventScroll: true });
        }
      });
    }
  };

  BoldPdp.prototype.showSticky = function (on) {
    if (this.stickyOn === on || !this.sticky) return;
    this.stickyOn = on;
    var bar = this.sticky;
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (on) bar.removeAttribute('inert');
    else bar.setAttribute('inert', '');
    document.body.classList.toggle('bld-sticky-on', on);
  };

  BoldPdp.prototype.flash = function (el) {
    el.classList.remove('is-highlighted');
    void el.offsetWidth;
    el.classList.add('is-highlighted');
    window.clearTimeout(el._bldFlash);
    el._bldFlash = window.setTimeout(function () { el.classList.remove('is-highlighted'); }, 1800);
  };

  /* Out-of-stock swatch line: white on dark colours, dark on light ones. */
  function toneSwatches() {
    /* Sticky bar dots carry their colour on themselves. */
    document.querySelectorAll('.bld__sticky-avail-dot:not([data-tone])').forEach(function (d) {
      var m = getComputedStyle(d).backgroundColor.match(/[d.]+/g);
      if (!m || m.length < 3 || (m.length > 3 && +m[3] === 0)) return;
      d.setAttribute('data-tone', 0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2] > 150 ? 'light' : 'dark');
    });
    document.querySelectorAll('.bld__swatch.is-unavailable').forEach(function (sw) {
      var dot = sw.querySelector('.bld__swatch-dot');
      if (!dot || sw.hasAttribute('data-tone')) return;
      var m = getComputedStyle(dot).backgroundColor.match(/[\d.]+/g);
      if (!m || m.length < 3 || (m.length > 3 && +m[3] === 0)) return;
      sw.setAttribute('data-tone', 0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2] > 150 ? 'light' : 'dark');
    });
  }

  function boot() {
    var el = document.querySelector('.bld');
    if (el && !el._bldPdp) el._bldPdp = new BoldPdp(el);
    toneSwatches();
    if (el && 'MutationObserver' in window && !el._bldTone) {
      var t;
      el._bldTone = new MutationObserver(function () {
        window.clearTimeout(t);
        t = window.setTimeout(toneSwatches, 100);
      });
      el._bldTone.observe(el, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
